import { render, staticRenderFns } from "./ChallengeApproveCalendar.vue?vue&type=template&id=70ff2b84&"
import script from "./ChallengeApproveCalendar.vue?vue&type=script&lang=js&"
export * from "./ChallengeApproveCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports